export const environment = {
  production: false,
  api: 'https://backend-consiglia-qa.digitalgex.com',
  sadiFilesApiBase: 'https://backend-consiglia-qa.digitalgex.com',
  storeIdentifierApi: 'https://demo-consiglia-tbpp.vercel.app',
  // Sesión central de navegador de PIVI (SSO entre canales). Ver pivi-session.ts.
  // Vacío: este front vive en digitalgex.com y PIVI en inversisa.net; la cookie no
  // viajaría entre dominios registrables distintos, así que el SSO queda apagado.
  piviBaseUrl: '',
  /** `idPlaform` de este canal en PIVI. */
  piviChannelId: 'recu',
  appVersion: '1.0.0-np',
  featureFlags: {
    enableNewFeature: true,
    enableBetaFeatures: false,
    enableBackendFlatFileUpload: true,
    recaudosDedupe: true,
    conciliations: {
      showHub: true,
      defaultModule: 'cash',
      executionConsolidation: true,
      modules: {
        cash: true,
        bank: true,
        platforms: true,
        collections: true,
      },
    },
  },
};
